<template>
  <div class="HomeView">

    <Head />
    <el-row :gutter="20">
      <el-col :span="4"><LeftBody /></el-col>
      <el-col :span="20"><RightBody /></el-col>
    </el-row>
    <Footer :email='email' :filing="filing" />
  </div>
</template>

<script>

// @ is an alias to /src
import Head from '@/components/Head.vue'
import Footer from '@/components/footer.vue'
import LeftBody from '@/components/leftBody.vue'
import RightBody from '@/components/RightBody.vue'

export default {
  name: 'HomeView',
  data() {
    return {
      email: 'workmoto@126.com',
      filing: '湘ICP备18015120号-1',
    }
  },
  components: {
    Head,
    LeftBody, RightBody,
    Footer,
  },
}
</script>
